module.exports = __webpack_public_path__ + "img/trade-01-th.580a4db5.svg";